// this is used to hide the burger icon so it won't overlap close icon
var OffCanvasMenuIconHandler = function (isActive) {
    var headerClassList = document.getElementById("header").classList;
    if (isActive) {
        headerClassList.add("to-top");
    }
    else {
        headerClassList.remove("to-top");
    }
};
export default OffCanvasMenuIconHandler;
